import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import ChatPage from './components/ChatPage';
import WechatCallback from './components/WechatCallback';
import WechatAuthHandler from './components/WechatAuthHandler';
import ModernLoginPage from './components/ModernLoginPage';
import SimpleRegisterPage from './components/SimpleRegisterPage';
import MaterialUploadPage from './components/MaterialUploadPage';
import ErrorBoundary from './components/ErrorBoundary';
import { AuthProvider } from './contexts/AuthContext';
import { AuthRoute } from './components/AuthRoute';
import './components/PageTransition.css';

function AppContent() {
    const location = useLocation();
    const [isTransitioning, setIsTransitioning] = useState(false);
    const [displayLocation, setDisplayLocation] = useState(location);

    useEffect(() => {
        if (location.pathname !== displayLocation.pathname) {
            // 开始淡出
            setIsTransitioning(true);

            // 等待淡出完成后切换页面并淡入
            setTimeout(() => {
                setDisplayLocation(location);
                setTimeout(() => {
                    setIsTransitioning(false);
                }, 20);
            }, 100);
        }
    }, [location.pathname, displayLocation.pathname]); // 只监听pathname变化，避免search参数导致的重复渲染

    return (
        <div className={`page-container ${isTransitioning ? 'transitioning' : ''}`}>
            <Routes location={displayLocation}>
                <Route path="/" element={
                    <AuthRoute>
                        <ChatPage />
                    </AuthRoute>
                } />
                <Route path="/login" element={<ModernLoginPage />} />
                <Route path="/register" element={
                    <AuthRoute>
                        <SimpleRegisterPage />
                    </AuthRoute>
                } />
                <Route path="/chat/:clientId" element={
                    <AuthRoute>
                        <ChatPage />
                    </AuthRoute>
                } />
                <Route path="/upload-materials" element={
                    <AuthRoute>
                        <MaterialUploadPage />
                    </AuthRoute>
                } />
                <Route path="/wechat/callback" element={<WechatCallback />} />
                <Route path="/wechat/auth" element={<WechatAuthHandler />} />
            </Routes>
        </div>
    );
}

function App() {
    return (
        <ErrorBoundary>
            <div className="App" style={{ position: 'relative', overflow: 'hidden' }}>
                <Router>
                    <AuthProvider>
                        <AppContent />
                    </AuthProvider>
                </Router>
            </div>
        </ErrorBoundary>
    );
}

export default App;
